class Templater {
	template;

	constructor(template = "") {
		this.template = template;
	}

	async getTemplate() {
		const data = await fetch(URL_API('getTemplate') + "&template=" + this.template);
		return await data.json();
	}

	async getTemplates() {
		const response = await fetch(URL_API('getTemplates'));
		return await response.json();
	}

	/** sample usage
	 *
	 * let someTemplate = await createTemplate(tpl_name);
	 * Note: tpl_name is used without a tpl_ prefix, but rather string you entered in PageParts
	 *
	 * const createTemplate = async () => {
	 * 		const template = await(new Templater(tpl_name)).getTemplate();
	 * 		return (new ChunkReplacer())
	 * 			.add('SOME_REPLACEMENT_SHORTCUT_1', someReplacementValue1)
	 *			.add('SOME_REPLACEMENT_SHORTCUT_2', someReplacementValue2)
	 * 			......
	 * 			.replace(template);
	 * }
	 * **/
}

module.exports = Templater;